import { Link } from "react-router-dom";
import { HanaLogo } from "@/components/marketing/MarketingPrimitives";

const NAV = [
  ["Le parcours", "/#parcours", "public-nav-journey-link"],
  ["Comment ça marche", "/#comment-ca-marche", "public-nav-how-link"],
  ["Établissements", "/professionnels", "public-nav-professionnels-link"],
  ["Patients", "/patients", "public-nav-patients-link"],
  ["Partenaires & données", "/pharma", "public-nav-partners-link"],
  ["Sécurité", "/securite", "public-nav-security-link"],
];

export const DEMO_PATH = "/professionnels#professional-contact-section";

export function PublicHeader({ current }) {
  return (
    <header className="sticky top-0 z-50 border-b border-emerald-100 bg-white/92 backdrop-blur-xl" data-testid="public-site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-4 lg:px-8">
        <Link to="/" className="flex items-center" data-testid="public-header-logo-link"><HanaLogo compact /></Link>
        <nav className="hidden items-center gap-6 lg:flex xl:gap-8" data-testid="public-header-navigation">
          {NAV.map(([label, to, testId]) => (
            <Link key={to} to={to} className={`whitespace-nowrap text-sm font-bold transition-colors hover:text-teal-500 ${current === to ? "text-teal-600" : "text-slate-500"}`} data-testid={testId}>{label}</Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to={DEMO_PATH} className="hidden min-h-11 items-center justify-center whitespace-nowrap rounded-xl bg-emerald-600 px-4 py-2.5 text-sm font-bold text-white shadow-[0_14px_28px_rgba(5,150,105,0.18)] transition-colors hover:bg-emerald-700 sm:inline-flex" data-testid="public-header-demo-link">Demander une démonstration</Link>
          <Link to="/login" className="inline-flex min-h-11 items-center justify-center whitespace-nowrap rounded-xl border border-emerald-100 bg-white px-4 py-2.5 text-sm font-bold text-emerald-700 transition-colors hover:border-emerald-300 hover:bg-emerald-50" data-testid="public-header-login-link">Se connecter</Link>
        </div>
      </div>
    </header>
  );
}

const FOOTER_COLUMNS = [
  ["Découvrir", [["Le parcours", "/#parcours"], ["Comment ça marche", "/#comment-ca-marche"], ["Sécurité et données", "/securite"]]],
  ["Pour", [["Établissements", "/professionnels"], ["Patients", "/patients"], ["Partenaires & données", "/pharma"]]],
  ["Accès", [["Se connecter", "/login"], ["Demander une démonstration", DEMO_PATH]]],
];

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export function PublicFooter() {
  return (
    <footer className="border-t border-emerald-100 bg-white px-5 py-12 lg:px-8" data-testid="public-footer">
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div data-testid="footer-brand-block">
          <HanaLogo />
          <p className="mt-3 max-w-xs text-sm font-semibold leading-6 text-slate-500" data-testid="footer-brand-tagline">Infrastructure numérique de coordination du parcours patient. Oncologie aujourd’hui.</p>
        </div>
        {FOOTER_COLUMNS.map(([title, links]) => (
          <div key={title} data-testid={`footer-column-${slug(title)}`}>
            <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-teal-500">{title}</p>
            <ul className="mt-4 space-y-2.5">
              {links.map(([label, to]) => (
                <li key={to}><Link to={to} className="text-sm font-bold text-slate-500 transition-colors hover:text-teal-500" data-testid={`footer-link-${slug(label)}`}>{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <p className="mx-auto mt-10 max-w-7xl border-t border-emerald-50 pt-6 text-xs font-semibold text-slate-400" data-testid="footer-legal-line">HANA structure le suivi. L’établissement garde la décision médicale. Données de santé protégées, conformité CNDP.</p>
    </footer>
  );
}
